import React from 'react'
import PropTypes from 'prop-types'

import './SlideNavigation.scss'

const SlideNavigation = ({isStart, isEnd, onNextSlide, onPreviousSlide, onRestart}) => {
  const handlePreviousKeyDown = (e) => {
    if (e.keyCode === 13) {
      onPreviousSlide()
    }
  }

  const handleRestartKeyDown = (e) => {
    if (e.keyCode === 13) {
      onRestart()
    }
  }

  const handleNextKeyDown = (e) => {
    if (e.keyCode === 13) {
      onNextSlide()
    }
  }

  return (
    <div styleName="slideshow-navigation">
      <div styleName="button-container">
        {isStart
          ? (
            <div styleName="prev-disabled" tabIndex={0} />
          )
          : (
            <div
              data-id="slide-prev"
              styleName="prev"
              onClick={onPreviousSlide}
              role="button"
              aria-label="Previous slide"
              tabIndex={0}
              onKeyDown={handlePreviousKeyDown}
            />
          )}
      </div>
      <div styleName="button-container">
        {isEnd
          ? (
            <div styleName="restart" onClick={onRestart} tabIndex={0} onKeyDown={handleRestartKeyDown} />
          )
          : (
            <div
              data-id="slide-next"
              styleName="next"
              onClick={onNextSlide}
              role="button"
              aria-label="Next slide"
              tabIndex={0}
              onKeyDown={handleNextKeyDown}
            />
          )}
      </div>
    </div>
  )
}

SlideNavigation.propTypes = {
  isStart: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  onNextSlide: PropTypes.func.isRequired,
  onPreviousSlide: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired
}

export default SlideNavigation
